import React from "react";
import avaliacaoneuropsicologicaImage from '../../assets/images/servicos/avaliacao-neuro.jpg';

const Avaliacaoneuropsicologica = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Avaliação Neuropsicológica</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Avaliação Neuropsicológica</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={avaliacaoneuropsicologicaImage} alt="Avaliação Neuropsicológica" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> O que é a avaliação neuropsicológica? </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>É uma avaliação que analisa o funcionamento cognitivo e comportamental da criança, e que tem como objetivo identificar possíveis alterações no desenvolvimento.</p><br />
                                        <p>Precisa ser feita por um profissional formado em psicologia e com especialização em neuropsicologia.</p><br />
                                        <p>É através dessa avaliação que pode-se identificar pontos que precisam de intervenção ou cuidado especial, e possibilita uma intervenção precoce e adequada.</p><br />
                                        <p><b>A avaliação neuropsicológica é um recurso muito importante quando há sinais que sugerem a existência de algum transtorno.</b></p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                    </section>
                </div>
            </div>
        </>
    );
};

export default Avaliacaoneuropsicologica;
